import { Tooltip } from "antd";
import { history } from '@umijs/max';
import { useCallback } from "react";

export interface SearchResultItemProps {
    title: string;
    id: number;
    ticket_number: number;
    callback?: () => void;
}

const CardItem = ({ searchResultItem, type = 'saas', callback }: { searchResultItem: SearchResultItemProps, type?: 'saas' | 'email', callback?: () => void }) => {
    const linkToDetail = useCallback(() => {
        if (callback) {
            callback();
        }
        history.push(`/ticket/${type}-ticket/detail/${searchResultItem.id}`);
    }, [searchResultItem.id]);

    return <div className="qd-grid qd-grid-cols-[1fr_auto] qd-py-1 qd-cursor-pointer" onClick={linkToDetail} >
        <Tooltip placement="left" title={searchResultItem.title} >
            <span className="qd-text-black qd-truncate qd-w-44" >{searchResultItem.title}</span>
        </Tooltip>
        <span>{searchResultItem.ticket_number}</span>
    </div>;
};

export default CardItem;
